import resolveFeatureFlag from './resolveFeatureFlag';

/**
 * Whether to render the V2 app shell — the switch in `navigation/index.tsx`
 * that picks the revamped header + body over the original ModelOverviewPage.
 * `dimensionsRevampV2Flag` only matters once this is on.
 *
 * A per-flag helper rather than an LD `bootstrap` in index.tsx: bootstrap
 * *replaces* the whole flag set rather than merging into it, so forcing
 * `uiRevamp` that way silently blanked every other flag — `blockDimDropdown`
 * and `dataImportDropdown` among them, which took the nav bar's hover
 * dropdowns and caret with them. This touches one flag and leaves the rest
 * of LD's response alone.
 *
 *   localStorage.setItem('uiRevamp', 'false')  // original ModelOverviewPage
 *   localStorage.removeItem('uiRevamp')        // back to default (V2)
 */
export const isUiRevampEnabled = (flags?: { uiRevamp?: boolean }): boolean =>
  resolveFeatureFlag('uiRevamp', flags?.uiRevamp);

export default isUiRevampEnabled;
